/**
 * Polyfill for canvas.toBlob if not supported
 */
if (!HTMLCanvasElement.prototype.toBlob) {
  Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
    value (callback, type, quality) {
      const canvas = this;
      setTimeout(() => {
        const binStr = atob(canvas.toDataURL(type, quality).split(',')[1]);
        const len = binStr.length;
        const arr = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          arr[i] = binStr.charCodeAt(i);
        }
        callback(new Blob([arr], { type: type || 'image/png' }));
      });
    },
  });
}

/**
 * Resize image to max 500x500 and convert to webp format
 * @param {File|Blob} file - Original image file or blob
 * @returns {Promise<File>} - Processed image file in webp format
 */
export function resizeAndConvertToWebp(file) {
  console.log('resizeAndConvertToWebp - starting, file:', file.name, file.type, file.size);
  return new Promise((resolve, reject) => {
    // Handle both File and Blob
    const fileName = file.name || (file instanceof File ? file.name : 'image.webp');
    console.log('resizeAndConvertToWebp - fileName:', fileName);
    
    const reader = new FileReader();
    
    reader.onload = (e) => {
      console.log('resizeAndConvertToWebp - file read, creating image...');
      const img = new Image();
      
      img.onload = () => {
        console.log('resizeAndConvertToWebp - image loaded, dimensions:', img.width, 'x', img.height);
        // Calculate new dimensions (max 500x500, maintain aspect ratio)
        let {width} = img;
        let {height} = img;
        
        if (width > 500 || height > 500) {
          const ratio = Math.min(500 / width, 500 / height);
          width = Math.round(width * ratio);
          height = Math.round(height * ratio);
          console.log('resizeAndConvertToWebp - resizing to:', width, 'x', height);
        } else {
          console.log('resizeAndConvertToWebp - no resize needed');
        }
        
        // Create canvas and draw resized image
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        
        // Use high quality image rendering
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(img, 0, 0, width, height);
        console.log('resizeAndConvertToWebp - canvas drawn, converting to webp...');
        
        // Convert to webp blob
        canvas.toBlob(
          (blob) => {
            if (!blob) {
              console.error('resizeAndConvertToWebp - failed to convert to webp');
              reject(new Error('Failed to convert image to webp'));
              return;
            }
            
            console.log('resizeAndConvertToWebp - webp blob created, size:', blob.size);
            // Create a new File object with webp extension
            const baseFileName = fileName.replace(/\.[^/.]+$/, '') || 'image';
            const webpFileName = `${baseFileName}.webp`;
            const webpFile = new File([blob], webpFileName, {
              type: 'image/webp',
              lastModified: Date.now(),
            });
            
            console.log('resizeAndConvertToWebp - webp file created:', webpFile.name, webpFile.type, webpFile.size);
            resolve(webpFile);
          },
          'image/webp',
          0.85, // Quality: 0.85 (85%)
        );
      };
      
      img.onerror = (error) => {
        console.error('resizeAndConvertToWebp - image load error:', error);
        reject(new Error('Failed to load image'));
      };
      
      img.src = e.target.result;
    };
    
    reader.onerror = (error) => {
      console.error('resizeAndConvertToWebp - file read error:', error);
      reject(new Error('Failed to read file'));
    };
    
    reader.readAsDataURL(file);
  });
}

